import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { IconButton } from "@mui/material";
import { PlayArrow, Pause } from "@mui/icons-material";
import { audioActions } from "store/audioSlice";
import { useTheme } from "@emotion/react";

const PlayPauseButton = () => {

  const theme = useTheme();

  const isPlaying = useSelector((state) => state.audio.isPlaying);
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(isPlaying ? audioActions.pause() : audioActions.play());
  };

  return (
    <IconButton 
      onClick={handleClick}
      size="large"
      sx={{
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.primary.contrastText,
        "&:hover": {
          backgroundColor: theme.palette.secondary.dark,
        },
      }}
    >
      {isPlaying ? <Pause /> : <PlayArrow />}
    </IconButton>
  );
};

export default PlayPauseButton;
